module.exports = __webpack_public_path__ + "img/treasury_01.0cc93568.png";